<select (change)="handleChange($event)" [ngModel]="state().currentRefinement" class="form-select" id="sortBy">
  @for (option of state().options; track option.value) {
    <option [value]="option.value">
      {{ option.label }}
    </option>
  }
</select>
<label for="sortBy" i18n>Sorter efter:</label>
